export default __webpack_public_path__ + "static/media/kitchen5-beforeA-1920w.8574e41f.avif";